export const envVarKeys = {
  NEXT_PUBLIC_ENABLE_WEBSDK: 'NEXT_PUBLIC_ENABLE_WEBSDK',
  NEXT_PUBLIC_GET_SESSION_ENDPOINT: 'NEXT_PUBLIC_GET_SESSION_ENDPOINT',
  NEXT_PUBLIC_UPDATE_SESSION_ENDPOINT: 'NEXT_PUBLIC_UPDATE_SESSION_ENDPOINT',
  NEXT_PUBLIC_GET_MVPOFFERS_ENDPOINT: 'NEXT_PUBLIC_GET_MVPOFFERS_ENDPOINT',
  NEXT_PUBLIC_ENABLE_DCA_V2: 'NEXT_PUBLIC_ENABLE_DCA_V2',
  SKIP_MVP_OFFERS: 'SKIP_MVP_OFFERS',
  NEXT_PUBLIC_ACDL_ENABLE_LOCALES: 'NEXT_PUBLIC_ACDL_ENABLE_LOCALES',
  NEXT_PUBLIC_PAYMENT_SERVICE_ID: 'NEXT_PUBLIC_PAYMENT_SERVICE_ID',
  NEXT_PUBLIC_PAYMENT_SERVICE_ENV: 'NEXT_PUBLIC_PAYMENT_SERVICE_ENV',
};
